module.exports = __webpack_public_path__ + "img/home-btn-share.26975fc4.png";